/**
 * Alert Bar Message
 *
 * @see src/templates/_partials/alertBar.twig
 * @see src/templates/_partials/header.twig
 * @property $refs
 */
export default ({
  debug = window?.APP?.CONFIG?.DEBUG || false,
  key,
  endTimestamp,
  startTimestamp,
}) => {
  return {
    debug: debug,
    key, // unique key for this alert bar - uses dateUpdated in Twig
    endTimestamp, // Optional unix timestamp for when the message should stop showing
    startTimestamp, // Optional Unix timestamp for when the message should start showing
    isVisible: false, // whether to show the message
    now: new Date().getTime() / 1000,
    showItAgainAfter: 60 * 60 * 24, // 1 day in seconds
    init() {
      if (this.debug) {
        console.log('AlertBar', {
          willShow: this.isEnabled && this.userHasNotDismissed,
          userHasNotDismissed: this.userHasNotDismissed,
          isEnabled: this.isEnabled,
          now: this.now,
          startTimestamp: this.startTimestamp,
          endTimestamp: this.endTimestamp,
        })
      }

      this.isVisible = this.isEnabled && this.userHasNotDismissed

      // Do side effects for closure
      this.$watch('isVisible', () => {
        if (!this.isVisible) {
          this.storeDismissal()
        }
      })
    },
    get storageKey() {
      return `alertBarDismissed-${this.key}`
    },
    get isEnabled() {
      return (
        !this.startTimestamp || this.startTimestamp < this.now
      )
      &&
      (
        !this.endTimestamp || this.endTimestamp > this.now
      )
    },
    get userHasNotDismissed() {
      const dismissedAt = Number(localStorage.getItem(this.storageKey))

      if (!dismissedAt) {
        return true
      }

      return (dismissedAt + this.showItAgainAfter) < this.now
    },
    storeDismissal() {
      localStorage.setItem(this.storageKey, this.now.toString())
    },
    dismiss() {
      this.isVisible = false
    },
  }
}
